"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJPreloadScene = void 0;
const KHPreloadScene_1 = require("./KH/KHPreloadScene");
class CGJPreloadScene extends KHPreloadScene_1.KHPreloadScene {
    constructor() {
        super("CGJPreloadScene");
    }
    nextScene() {
        return "CGJMenuScene";
    }
    fontsToLoad() {
        return ["NovaMono"];
    }
    loadAssets() {
        super.loadAssets();
        this.load.image('Apple', 'assets/Apple.png');
        this.load.image('Pixel', 'assets/Pixel.png');
        this.load.image('Pointer', 'assets/Pointer.png');
        this.load.spritesheet('Slime', 'assets/SlimeAll.png', { frameWidth: 16, frameHeight: 16 });
        this.load.image('SlimeDead', 'assets/SlimeDead.png');
        this.load.spritesheet('Boy', 'assets/BoyAll.png', { frameWidth: 16, frameHeight: 16 });
        this.load.image('BoyDead', 'assets/BoyDead.png');
        this.load.spritesheet('Girl', 'assets/GirlAll.png', { frameWidth: 16, frameHeight: 16 });
        this.load.image('GirlDead', 'assets/GirlDead.png');
        this.load.spritesheet('Skeleton', 'assets/SkeletonAll.png', { frameWidth: 16, frameHeight: 16 });
        this.load.image('SkeletonDead', 'assets/SkeletonDead.png');
        this.load.image('Space', 'assets/Space.jpg');
        this.load.image('StoneHead', 'assets/StoneHead.png');
        this.load.image('StoneHead2', 'assets/StoneHead2.png');
        this.load.image('WinDrawing', 'assets/WinDrawing.jpg');
        this.load.spritesheet('Grass_Summer', 'assets/Grass_SummerAll.png', { frameWidth: 32, frameHeight: 32 });
        this.load.spritesheet('Grass_Spring', 'assets/Grass_SpringAll.png', { frameWidth: 32, frameHeight: 32 });
        this.load.spritesheet('Grass_Fall', 'assets/Grass_FallAll.png', { frameWidth: 32, frameHeight: 32 });
        this.load.spritesheet('Grass_Winter', 'assets/Grass_WinterAll.png', { frameWidth: 32, frameHeight: 32 });
        this.load.audio('Tick', 'assets/Tick.mp3');
        this.load.audio('Cricket', 'assets/Cricket.mp3');
        this.load.audio('Bird', 'assets/Bird.mp3');
        this.load.audio('Gong', 'assets/Gong.mp3');
        this.load.audio('Pickup', 'assets/Pickup.mp3');
        this.load.audio('Music', 'assets/Music.mp3');
        this.load.audio('Death', 'assets/Death.mp3');
        this.scene.run("KHInputScene");
    }
    create() {
        this.setNearest('Apple');
        this.setNearest('Pixel');
        this.setNearest('Grass_Summer');
        this.setNearest('Grass_Spring');
        this.setNearest('Grass_Fall');
        this.setNearest('Grass_Winter');
        this.setNearest('Slime');
        this.setNearest('SlimeDead');
        this.setNearest('Boy');
        this.setNearest('BoyDead');
        this.setNearest('Girl');
        this.setNearest('GirlDead');
        this.setNearest('Skeleton');
        this.setNearest('SkeletonDead');
        this.setNearest('StoneHead');
        this.setNearest('StoneHead2');
        super.create();
    }
    setNearest(key) {
        const tex = this.sys.textures.get(key);
        if (tex)
            tex.setFilter(Phaser.Textures.FilterMode.NEAREST);
        else
            console.warn("Error setting nearest on " + key);
    }
}
exports.CGJPreloadScene = CGJPreloadScene;
